let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aQybG")).then(() => parcelRequire('jOTEC'));